<template>
  <div class="chatitem mb-2 p-2" :class="isMyHandle(chat.handle) ? 'chatitem-self' : null">
    <span
      :class="isMyHandle(chat.handle) ? 'my-text' : 'other-text'"
    >{{chat.createdAt | moment("[le] DD/MM/YY [à] HH[h]mm")}}, {{ chat.handle }} a dit :&nbsp;</span>
    <br>
    <span>{{ chat.message }}</span>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ChatItem",
  props: ["chat"],
  computed: {
    ...mapState("chat", ["handle"])
  },
  methods: {
    isMyHandle(handle) {
      return handle === this.handle;
    }
  }
};
</script>

<style>
.chatitem {
  background-color: #e6ffe6;
  border-radius: 0.25rem;
  text-align: left;
}
.chatitem-self {
  background-color: #fff8d9;
}
.my-text {
  color: #f00;
  font-size: 0.75rem;
  font-weight: bold;
}
.other-text {
  color: #2aab2a;
  font-size: 0.75rem;
  font-weight: bold;
}
</style>

